import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => (
  <path fill={color} d="M80.7 20.2H19.3a5.8 5.8 0 0 0-5.8 5.8v37.4a5.8 5.8 0 0 0 5.8 5.8h21.6l8.6 10.6 8.2-10.6h23a5.8 5.8 0 0 0 5.8-5.8V26a5.8 5.8 0 0 0-5.8-5.8zM50 53.4H26v-4.8h24zm24-11.6H26V37h48z" />
));
